export default __webpack_public_path__ + "static/media/csi_mobile_app.04d0bdbb.png";